/**
 * Proposal Meta Component
 * Displays author, creation time, and time remaining
 */
export function ProposalMeta({ author, createdAt, endsAt, status }) {
  // Calculate time remaining
  const getTimeRemaining = () => {
    if (!endsAt || status !== 'active') return null;

    const now = new Date();
    const end = new Date(endsAt);
    const diff = end - now;

    if (diff <= 0) return 'Ended';

    const days = Math.floor(diff / (1000 * 60 * 60 * 24));
    const hours = Math.floor((diff % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));

    if (days > 0) {
      return `${days}d ${hours}h`;
    } else if (hours > 0) {
      return `${hours}h`;
    } else {
      const minutes = Math.floor((diff % (1000 * 60 * 60)) / (1000 * 60));
      return `${minutes}m`;
    }
  };

  const timeRemaining = getTimeRemaining();
  const isUrgent = endsAt && status === 'active' && new Date(endsAt) - new Date() < 24 * 60 * 60 * 1000;

  return (
    <div className="t24-proposal-meta">
      {/* Author */}
      <div className="t24-proposal-author">
        <span>👤 {author || 'Unknown'}</span>
      </div>

      {/* Time Remaining */}
      {timeRemaining && (
        <div className={`t24-proposal-time-remaining ${isUrgent ? 'urgent' : ''}`}>
          <span>
            ⏱️ {timeRemaining} {window.t24Governance.strings.timeRemaining}
          </span>
        </div>
      )}
    </div>
  );
}
